import { render } from "./DepartmentDetails.vue?vue&type=template&id=7876689c&scoped=true"
import script from "./DepartmentDetails.vue?vue&type=script&lang=js"
export * from "./DepartmentDetails.vue?vue&type=script&lang=js"

import "./DepartmentDetails.vue?vue&type=style&index=0&id=7876689c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7876689c"]])

export default __exports__